import { memo } from 'react';
import { useParams } from 'react-router-dom';

export const genericReactMemo: <T>(component: T) => T = memo;

/** берет из маршрута `param` (через `useParams`) и преобразовывает в число */
export const useParamAsNumber = (param: string) => {
  const params = useParams();
  return params[param] ? +params[param] : undefined;
};
